<script setup>
import {nextTick, ref, watch} from 'vue';

const props = defineProps({
  step: {
    required: true,
    type: Number,
  },
  title: {
    required: true,
    type: String,
  },
  active: {
    required: false,
    type: Boolean,
  },
});

const stepBoxRef = ref(null);

watch(() => props.active, async (isActive) => {
  if (!isActive) {
    return;
  }

  await nextTick();

  const element = stepBoxRef.value;

  if (!(element instanceof HTMLElement)) {
    return;
  }

  element.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });
});
</script>

<template>
  <div
    ref="stepBoxRef"
    class="tw-p-4 md:tw-p-6 tw-flex tw-flex-col tw-gap-4 tw-bg-white tw-rounded-lg"
  >
    <div class="tw-flex tw-gap-4 tw-items-center tw-mb-4">
      <span
        class="tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-full tw-text-lg tw-font-bold tw-text-white tw-transition-all"
        :class="active ? 'tw-bg-primary' : 'tw-bg-grey'"
      >
        {{ step }}
      </span>
      <div class="tw-flex tw-flex-col tw-gap-2">
        <h4 class="tw-text-xl tw-font-bold tw-m-0">
          {{ title }}
        </h4>
        <slot name="subtitle" />
      </div>
    </div>
    <slot name="default" />
  </div>
</template>

<style scoped>

</style>